import React from 'react'
import RoutesMenusLogin from './Login'
import RoutesMenusHome from './Home'
import RoutesMenusPublicInscricao from './Inscricao'

export default function RoutesMenusPublic() {
    console.log('Public config')
    return (
        <>
            <RoutesMenusLogin />
            <RoutesMenusHome />
            <RoutesMenusPublicInscricao />
        </>
    )
}
